import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';

import { BeraV2Service } from '@/infra/services/bera-v2';
import { openInNewTab } from '@/utils/open-in-new-tab';
import type { BeraPdfDownload } from '@/types/Bera';

interface DownloadBeraReportV2PdfParams {
	id: string;
	organization_id: string;
	company_id: string;
	locale: string;
}

const Service = BeraV2Service.getInstance();

function openDownload(data: BeraPdfDownload): void {
	openInNewTab(data.url);
}

export function useDownloadBeraReportV2Pdf() {
	return useMutation<BeraPdfDownload, Error, DownloadBeraReportV2PdfParams>(
		(params: DownloadBeraReportV2PdfParams) => Service.downloadReportPdf(params),
		{
			onSuccess: openDownload,
			onError: () => {
				message.error(I18n.get('Failed to generate the report'));
			}
		}
	);
}
